import { Colors, FlexBox, Skeleton } from '@brg/ui';
import { FC, ReactNode, useMemo} from 'react';
import { PageControl } from './styles';
import { ReactComponent as BackSvg } from './assets/back.svg';
import { ReactComponent as NextSvg } from './assets/next.svg';
import styled, { css } from 'styled-components';



export interface PaginationLayoutProps {
    isLoading?: boolean;
    paging?: ReactNode;
    button?: ReactNode;
    hidden?: boolean;
    disableOffset?: boolean;
    showArrows?: boolean;
}

const PaginationRoot = styled(FlexBox)<{ hidden?: boolean, disableOffset?: boolean, showArrows?: boolean }>`
    flex-wrap: wrap;
    height: 50px;
    max-height: 50px;
    flex-flow: row;
    justify-content: ${({showArrows}) => showArrows ? 'center' : 'flex-start'};
    align-items: center;
    padding: 16px 16px 18px;
    
`
const PageNumber = styled(FlexBox)<{ active?: boolean; disabled?: boolean }>`
    justify-content: center;
    align-items: center;
    min-width: 32px;
    height: 32px;
    border-radius: 3px;
    color: #909090;
    cursor: pointer;
    user-select: none;
    font-size: 15px;
    line-height: 20px;
    &:hover {
        color: ${Colors.geoWhite73};
    }
    ${(p) =>
        p.active
            ? css`
                  color: #000000;
                  background: #ffffff !important;
                  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
              `
            : null};

    ${(p) =>
        p.disabled
            ? css`
                  curson: initial !important;
              `
            : null};
`;


export const PaginationLayout: FC<PaginationLayoutProps> = (props) => {
    const { isLoading, paging, button, hidden, disableOffset, showArrows } = props;

    return (
        <PaginationRoot
            style={{ minWidth: 'calc(100% - 20px)' }}
            gy={46}
            width="100%"
            justify="space-between"
            align="center"
            hidden={hidden}
            disableOffset={disableOffset}
            showArrows={showArrows}
        >
            {!isLoading && button}
            {isLoading ? (
                <FlexBox gx={8}>
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                </FlexBox>
            ) : (
                paging
            )}
        </PaginationRoot>
    );
};


const PaggingItemWrapper = styled(FlexBox)`
    .pagging_item {
        margin-left: 6px;

        &:first-child {
        margin-left: 0;
        }
    }
`;

export interface PaginationProps {
    isLoading?: boolean;
    page: number;
    pages: number;
    onPageChange?: (page: number) => void;
    isCanLoadMore?: boolean;
    loadMore?: () => void;
    showLoadMore?: boolean;
    hidden?: boolean;
    disableOffset?: boolean;
}

export const ModalPagination: FC<PaginationProps> = (props) => {
    const { isLoading, page, onPageChange, pages, hidden } = props;
    const showArrows = pages > 9;
    const backStep = showArrows ? 3 : 4;
    const forwardStep = showArrows ? 3 : 4;
    const totalSteps = 7;
    
    const pagesList = useMemo(() => {
        const arr = Array<number>();

        if (pages <= 9) {
            for (let i = 1; i <= pages; i++) {
                arr.push(i);
            }
        } else {
            let startStep = page - backStep;
            let endStep = page + forwardStep;
            if (startStep < 1) {
                startStep = 1;
                endStep = Math.min(pages, totalSteps);
            } else if (endStep > pages) {
                endStep = pages;
                startStep = Math.max(1, pages - totalSteps + 1);
            }
            for (let i = startStep; i <= endStep; i++) {
                arr.push(i);
            }
        }

        return arr;
    }, [page, pages, backStep, forwardStep, totalSteps]);
      

    const onPageChangeCreate = (p: number) => () => {
        onPageChange?.(p);
    };
    
    const showLast = pages - page > backStep;

    const showNext = useMemo(() => (pagesList[forwardStep] > 0 && page < pagesList[pagesList.length - 1]), [pagesList, page, forwardStep])

    return (
        <PaginationLayout
            isLoading={isLoading}
            disableOffset={props.disableOffset}
            showArrows={showArrows}//
            paging={
                pages > 1 && (
                  <>
                    <PaggingItemWrapper gx={8}>
                        
                        {showArrows && showLast && (
                            <PageControl onClick={onPageChangeCreate(page - 1)}>
                                <BackSvg />
                            </PageControl>
                            )}
                      
                        {pagesList.map((value, index) => (
                            <div key={`pi_${value}_ ${index}`} className='pagging_item'>
                                {value > 0 ? (
                                    <PageNumber onClick={onPageChangeCreate(value)} active={value === page}>
                                        {value}
                                    </PageNumber>
                                ) : null}
                            </div>
                        ))}
                        {showArrows && showNext && (
                            <PageControl onClick={onPageChangeCreate(page + 1)}>
                                <NextSvg />
                            </PageControl>
                        )}
                    </PaggingItemWrapper>
                  </>
                )
            }
            hidden={hidden}
        />
    );
};
import { Colors, FlexBox, Skeleton } from '@brg/ui';
import { FC, ReactNode, useMemo} from 'react';
import { PageControl } from './styles';
import { ReactComponent as BackSvg } from './assets/back.svg';
import { ReactComponent as NextSvg } from './assets/next.svg';
import styled, { css } from 'styled-components';



export interface PaginationLayoutProps {
    isLoading?: boolean;
    paging?: ReactNode;
    button?: ReactNode;
    hidden?: boolean;
    disableOffset?: boolean;
    showArrows?: boolean;
}

const PaginationRoot = styled(FlexBox)<{ hidden?: boolean, disableOffset?: boolean, showArrows?: boolean }>`
    flex-wrap: wrap;
    height: 50px;
    max-height: 50px;
    flex-flow: row;
    justify-content: ${({showArrows}) => showArrows ? 'center' : 'flex-start'};
    align-items: center;
    padding: 16px 16px 18px;
    
`
const PageNumber = styled(FlexBox)<{ active?: boolean; disabled?: boolean }>`
    justify-content: center;
    align-items: center;
    min-width: 32px;
    height: 32px;
    border-radius: 3px;
    color: #909090;
    cursor: pointer;
    user-select: none;
    font-size: 15px;
    line-height: 20px;
    &:hover {
        color: ${Colors.geoWhite73};
    }
    ${(p) =>
        p.active
            ? css`
                  color: #000000;
                  background: #ffffff !important;
                  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
              `
            : null};

    ${(p) =>
        p.disabled
            ? css`
                  curson: initial !important;
              `
            : null};
`;


export const PaginationLayout: FC<PaginationLayoutProps> = (props) => {
    const { isLoading, paging, button, hidden, disableOffset, showArrows } = props;

    return (
        <PaginationRoot
            style={{ minWidth: 'calc(100% - 20px)' }}
            gy={46}
            width="100%"
            justify="space-between"
            align="center"
            hidden={hidden}
            disableOffset={disableOffset}
            showArrows={showArrows}
        >
            {!isLoading && button}
            {isLoading ? (
                <FlexBox gx={8}>
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                    <Skeleton width={32} height={32} />
                </FlexBox>
            ) : (
                paging
            )}
        </PaginationRoot>
    );
};


const PaggingItemWrapper = styled(FlexBox)`
    .pagging_item {
        margin-left: 6px;

        &:first-child {
        margin-left: 0;
        }
    }
`;

export interface PaginationProps {
    isLoading?: boolean;
    page: number;
    pages: number;
    onPageChange?: (page: number) => void;
    isCanLoadMore?: boolean;
    loadMore?: () => void;
    showLoadMore?: boolean;
    hidden?: boolean;
    disableOffset?: boolean;
}

export const ModalPagination: FC<PaginationProps> = (props) => {
    const { isLoading, page, onPageChange, pages, hidden } = props;
    const showArrows = pages > 9;
    const backStep = showArrows ? 3 : 4;
    const forwardStep = showArrows ? 3 : 4;
    const totalSteps = 7;
    
    const pagesList = useMemo(() => {
        const arr = Array<number>();

        if (pages <= 9) {
            for (let i = 1; i <= pages; i++) {
                arr.push(i);
            }
        } else {
            let startStep = page - backStep;
            let endStep = page + forwardStep;
            if (startStep < 1) {
                startStep = 1;
                endStep = Math.min(pages, totalSteps);
            } else if (endStep > pages) {
                endStep = pages;
                startStep = Math.max(1, pages - totalSteps + 1);
            }
            for (let i = startStep; i <= endStep; i++) {
                arr.push(i);
            }
        }

        return arr;
    }, [page, pages, backStep, forwardStep, totalSteps]);
      

    const onPageChangeCreate = (p: number) => () => {
        onPageChange?.(p);
    };
    
    const showLast = pages - page > backStep;

    const showNext = useMemo(() => (pagesList[forwardStep] > 0 && page < pagesList[pagesList.length - 1]), [pagesList, page, forwardStep])

    return (
        <PaginationLayout
            isLoading={isLoading}
            disableOffset={props.disableOffset}
            showArrows={showArrows}//
            paging={
                pages > 1 && (
                  <>
                    <PaggingItemWrapper gx={8}>
                        
                        {showArrows && showLast && (
                            <PageControl onClick={onPageChangeCreate(page - 1)}>
                                <BackSvg />
                            </PageControl>
                            )}
                      
                        {pagesList.map((value, index) => (
                            <div key={`pi_${value}_ ${index}`} className='pagging_item'>
                                {value > 0 ? (
                                    <PageNumber onClick={onPageChangeCreate(value)} active={value === page}>
                                        {value}
                                    </PageNumber>
                                ) : null}
                            </div>
                        ))}
                        {showArrows && showNext && (
                            <PageControl onClick={onPageChangeCreate(page + 1)}>
                                <NextSvg />
                            </PageControl>
                        )}
                    </PaggingItemWrapper>
                  </>
                )
            }
            hidden={hidden}
        />
    );
};
